export default __webpack_public_path__ + "static/audio-cardio-banner-b9b29ebec35d83d2fd618e9961e5d3e9.webp";